import React, { useContext } from 'react';

import { Route } from '@gogame/screens';
import { Sentry } from '@gogame/components';

import { ConceptDetailsRouteElement } from 'scenes/Gallery/GalleryPage/Concepts/ConceptDetails/ConceptDetailsRouteElement';
import {
  CONCEPT_ID,
  VIEW_MODE_DATATABLE,
  VIEW_MODE_TILES,
} from 'scenes/Gallery/GalleryPage/constants';

import ConceptTiles from './ConceptTiles';
import ConceptsDataTableOriginal from './ConceptsDataTable';
import ConceptDataTableContext, {
  ConceptsDataTableProvider,
} from './ConceptsDataTableContext';

export { ConceptsDataTableProvider };

export const ConceptsDataTable = ({ height, tabs }) => {
  const { viewMode } = useContext(ConceptDataTableContext);

  return (
    <React.Fragment>
      {
        {
          [VIEW_MODE_DATATABLE]: (
            <ConceptsDataTableOriginal height={height} tabs={tabs} />
          ),
          [VIEW_MODE_TILES]: <ConceptTiles height={height} tabs={tabs} />,
        }[viewMode]
      }
      <Sentry.Routes>
        <Route
          path={`:${CONCEPT_ID}`}
          element={<ConceptDetailsRouteElement />}
        />
      </Sentry.Routes>
    </React.Fragment>
  );
};
